/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { tagModelSchema } from "./tagModelSchema.ts";
import { z } from "zod";

export const tagModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => tagModelSchema))
    })